import { lazy } from 'react';

export { SERVICES } from './routes';
export { default as routes } from './routes';

export { default as Services } from './pages/Services';
export { default as NewServiceForm } from './register-service-form/pages/NewServiceForm';

export const ServicesFeature = lazy(() => import('./pages/ServicesFeature'));
